import { composeUseModal } from "@deliverr/ui-facility/lib-facility/common/modal";
import { visibleScanModalsState } from "./ScanModalState";

export const useCrossdockModal = composeUseModal(visibleScanModalsState);
